import * as XLSX from 'xlsx';

export const downloadClientSampleTemplate = (format: 'xlsx' | 'csv' = 'xlsx') => {
  const headers = [
    'Customer Name',
    'Customer Phone',
    'Customer Address',
    'Product Name',
    'Quantity',
    'Cod Amount',
    'Color',
    'Size',
    'Weight',
    'Note',
    'Order Number',
  ];

  const sampleRows = [
    [
      'Farhana Ahmed',
      '01525239969',
      'Road 8, House 50, Dhaka Cantonment, Dhaka',
      'Rose Flora Print Sharara Three Piece',
      1,
      1279,
      'Blue',
      '40',
      '',
      'Please deliver between 2 PM and 5 PM',
      'ORD-296A86CB',
    ],
    [
      'Sayeda Sultana',
      '01949737311',
      'Staff Quarters, Green City Noor Masjid, Tongi, Gazipur',
      'Premium Flora Print Sharara Three Piece',
      1,
      1279,
      'Maroon',
      '42',
      '',
      'Call customer before delivering',
      '',
    ],
    [
      'Tanvir Hossain',
      '01712345678',
      'Agrabad Commercial Area, Chittagong',
      'Rose Flora Print Sharara Three Piece',
      2,
      2498,
      'Black',
      'XL',
      '1kg',
      'color: Black, size: XL, Note: Urgent order',
      '',
    ],
  ];

  const ws = XLSX.utils.aoa_to_sheet([headers, ...sampleRows]);
  ws['!cols'] = [
    { wch: 20 },
    { wch: 16 },
    { wch: 45 },
    { wch: 38 },
    { wch: 10 },
    { wch: 14 },
    { wch: 12 },
    { wch: 10 },
    { wch: 10 },
    { wch: 38 },
    { wch: 18 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Orders Import');

  if (format === 'csv') {
    XLSX.writeFile(wb, 'orders_sample_template.csv', { bookType: 'csv' });
  } else {
    XLSX.writeFile(wb, 'orders_sample_template.xlsx', { bookType: 'xlsx' });
  }
};

